import { render, staticRenderFns } from "./CogDetective.vue?vue&type=template&id=2b8fb090&scoped=true&"
import script from "./CogDetective.vue?vue&type=script&lang=js&"
export * from "./CogDetective.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=2b8fb090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8fb090",
  null
  
)

export default component.exports